import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import type { HeadlineSubheadingSection } from '../../../../types/FormBuilder.types'

const formBuilderQueue = useBuilder('formBuilder')

const HeadlineCommands = {
  updateBlock: formBuilderQueue.createBlockCommand<HeadlineSubheadingSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { HeadlineCommands }
